/**
 * Initializes a subtest set to conform with uA requirements.
 * @param {object} subtest the subtest set from sets collection
 * @param {number} index display index of the subtest
 */
export default function initSubtest(subtest, index) {
  let displayName
  subtest.displayName
    ? (displayName = subtest.displayName)
    : (displayName = subtest.name)
  let maxNodeLevels = 0
  let maxRaw = 0
  let nodeTag = ""
  let testType = "Subtest"
  let timeLimit = 0
  let rawToScaleScoring = { 0: 0 }
  let directions = ""
  let sectionBreaks = []
  let timeManagementEasy = null
  let timeManagementHard = null
  let precisionQuestions = null
  let precisionComparables = null
  let dataRepresentationPassages = null
  let researchSummaryPassages = null
  let conflictingViewpointsPassages = null
  let testCategory = null
  let groupName = null
  let gradeLevels = null

  if (subtest.maxNodeLevels) maxNodeLevels = subtest.maxNodeLevels
  if (subtest.maxRaw) maxRaw = subtest.maxRaw
  if (subtest.nodeTag) nodeTag = subtest.nodeTag
  if (subtest.nodeTag) testCategory = subtest.testCategory
  if (subtest.testType) testType = subtest.testType
  if (subtest.timeLimit) timeLimit = subtest.timeLimit
  if (subtest.rawToScaleScoring) rawToScaleScoring = subtest.rawToScaleScoring
  if (subtest.directions) directions = subtest.directions
  if (subtest.sectionBreaks) sectionBreaks = subtest.sectionBreaks
  if (subtest.timeManagementEasy)
    timeManagementEasy = subtest.timeManagementEasy
  if (subtest.timeManagementHard)
    timeManagementHard = subtest.timeManagementHard
  if (subtest.precisionQuestions)
    precisionQuestions = subtest.precisionQuestions
  if (subtest.precisionComparables)
    precisionComparables = subtest.precisionComparables
  if (subtest.dataRepresentationPassages)
    dataRepresentationPassages = subtest.dataRepresentationPassages
  if (subtest.researchSummaryPassages)
    researchSummaryPassages = subtest.researchSummaryPassages
  if (subtest.conflictingViewpointsPassages)
    conflictingViewpointsPassages = subtest.conflictingViewpointsPassages
  if (subtest.groupName) groupName = subtest.groupName
  if (subtest.gradeLevels) gradeLevels = subtest.gradeLevels

  let assessmentSubtest = {
    name: subtest.name,
    setId: subtest.id,
    displayName,
    index: index,
    content: subtest.content,
    displayName,
    maxNodeLevels,
    maxRaw,
    nodeTag,
    testType,
    timeLimit,
    rawToScaleScoring,
    directions,
    sectionBreaks,
    timeManagementEasy,
    timeManagementHard,
    precisionQuestions,
    precisionComparables,
    dataRepresentationPassages,
    researchSummaryPassages,
    conflictingViewpointsPassages,
    testCategory,
    groupName,
    gradeLevels
  }

  if (subtest.bubbleSheetSubtest) {
    const { externalTestLink, source, bubbleSheetSubtest } = subtest
    assessmentSubtest = {
      ...assessmentSubtest,
      externalTestLink,
      source,
      bubbleSheetSubtest
    }
  }

  return assessmentSubtest
}
